module.exports = __webpack_public_path__ + "2430bbdb.webp";